import { isEmpty } from 'lodash';
import moment from 'moment';

import { Nullable } from 'types';
import { apiContent } from 'utilities/http/api/pricing/apiContent';

export const pricingContentKey = 'pricingContent';
export let pricingContent = JSON.parse(localStorage.getItem(pricingContentKey) ?? '{}');

export const fetchPricingContent = async () => {
  const response = await apiContent.getPricingContent();
  if (response.isOk && typeof response.json.pricingAppContent === 'object') {
    const content = {
      ...response.json.pricingAppContent,
      fetchedDate: new Date().toISOString(),
    };

    localStorage.setItem(pricingContentKey, JSON.stringify(content));
  }
};

export const isPricingContentExpired = () => {
  const differenceBetweenFetchedDateAndNow = moment().diff(
    pricingContent.fetchedDate,
    'hours',
  );
  const twentyFourHours = 24;
  return twentyFourHours < differenceBetweenFetchedDateAndNow;
};

export const getPricingContentStorage = async () => {
  if (
    isEmpty(pricingContent) ||
    !localStorage.getItem(pricingContentKey) ||
    isPricingContentExpired()
  ) {
    await fetchPricingContent();
    pricingContent = JSON.parse(localStorage.getItem(pricingContentKey) as string);
  }
};

export const getNameOfPricingContentFieldById = (field: string, id: Nullable<number>) => {
  if (!id) return null;
  const matchingItem = pricingContent[field]?.find(
    (item: { id: number; name: string }) => {
      return item.id === id;
    },
  );

  return matchingItem?.name || null;
};
